<template>
  <section id="contact" class="contact-container">
    <div class="content-wrapper">
      <h2 class="title">Contact.</h2>
      <p class="description">
        새로운 기회와 기술적 대화는 언제나 환영입니다.<br />
        궁금한 점이 있다면 언제든 연락 주세요.
      </p>

      <div class="contact-list">
        <div class="contact-item">
          <span class="label">Email 1</span>
          <a href="mailto:trust00005@naver.com" class="value">
            trust00005@naver.com
            <span class="arrow">↗</span>
          </a>
        </div>

        <div class="contact-item">
          <span class="label">Email 2</span>
          <a href="mailto:dev0521david@gmail.com" class="value">
            dev0521david@gmail.com
            <span class="arrow">↗</span>
          </a>
        </div>

        <div class="contact-item">
          <span class="label">GitHub</span>
          <a
            href="https://github.com/kimdavid0521"
            target="_blank"
            class="value"
          >
            https://github.com/kimdavid0521
            <span class="arrow">↗</span>
          </a>
        </div>

        <div class="contact-item">
          <span class="label">Tech Blog</span>
          <a
            href="https://tech-blog-eight-blue.vercel.app/"
            target="_blank"
            class="value"
          >
            https://tech-blog-eight-blue.vercel.app
            <span class="arrow">↗</span>
          </a>
        </div>

        <div class="contact-item">
          <span class="label">Portfolio site</span>
          <a
            href="https://davidportfolio-pi.vercel.app"
            target="_blank"
            class="value"
          >
            https://davidportfolio-pi.vercel.app
            <span class="arrow">↗</span>
          </a>
        </div>
      </div>
    </div>

    <footer class="footer">
      <p>© 2025 Kim Tae-young.</p>
    </footer>
  </section>
</template>

<script>
export default {
  name: "ContactSection",
};
</script>

<style scoped>
.contact-container {
  padding: 120px 5% 50px;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.content-wrapper {
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  text-align: left; /* 왼쪽 정렬로 변경하여 리스트 느낌 강조 */
}

.title {
  font-size: 4rem;
  margin-bottom: 20px;
  color: var(--text-primary);
  letter-spacing: -0.02em;
}

.description {
  font-size: 1.2rem;
  color: var(--text-secondary);
  margin-bottom: 60px;
  line-height: 1.6;
}

.contact-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.contact-item {
  display: flex;
  align-items: baseline;
  gap: 30px;
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 15px;
  transition: border-color 0.3s ease;
}

.contact-item:hover {
  border-bottom-color: var(--accent-color);
}

.label {
  font-family: "JetBrains Mono", monospace;
  font-size: 1rem;
  color: var(--text-tertiary);
  min-width: 80px; /* 라벨 너비 고정 */
  font-weight: 500;
}

.value {
  font-size: 1.5rem; /* 폰트 키움 */
  color: var(--text-primary);
  text-decoration: none;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: color 0.2s ease;
}

.value:hover {
  color: var(--accent-color);
}

.arrow {
  font-size: 1rem;
  opacity: 0;
  transform: translate(-5px, 5px);
  transition: all 0.2s ease;
}

.value:hover .arrow {
  opacity: 1;
  transform: translate(0, 0);
}

.footer {
  margin-top: 100px;
  text-align: center;
  color: var(--text-tertiary);
  font-size: 0.9rem;
}

.small {
  font-size: 0.8rem;
  margin-top: 5px;
  opacity: 0.7;
}

/* 모바일 대응 */
@media (max-width: 768px) {
  .title {
    font-size: 3rem;
  }
  .contact-item {
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
  }
  .label {
    font-size: 0.9rem;
  }
  .value {
    font-size: 1.2rem;
  }
}
</style>
